import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { Grid } from 'semantic-ui-react';

import { default as UniversalLink } from '@plone/volto/components/manage/UniversalLink/UniversalLink';

import { STATUS_VOCABULARY_ID } from '../../../constants';
import FBCLoader from '../../FBCLoader/FBCLoader';
import { LocationActions } from './LocationActions';

export const LocationsTable = ({ dispatch, locations, loading, isManager }) => {
  const statuses = useSelector(
    (state) => state.vocabularies[STATUS_VOCABULARY_ID],
  );

  const columnSizes = [4, 2, 2, 2, 2];
  return loading ? (
    <FBCLoader />
  ) : locations.length > 0 ? (
    <Grid className="locations-management" stackable>
      <Grid.Row className="locations-management-header">
        <Grid.Column width={columnSizes[0]} className="manage-location">
          <FormattedMessage id="Locations" defaultMessage="Locations" />
        </Grid.Column>
        <Grid.Column width={columnSizes[1]} className="manage-status">
          <FormattedMessage id="Status" defaultMessage="Status" />
        </Grid.Column>
        <Grid.Column width={columnSizes[2]} className="manage-actions">
          <FormattedMessage id="Requested" defaultMessage="Requested" />
        </Grid.Column>
        <Grid.Column width={columnSizes[3]} className="manage-actions">
          <FormattedMessage id="Expiration" defaultMessage="Expiration" />
        </Grid.Column>
        <Grid.Column width={columnSizes[4]} className="manage-expiration">
          <FormattedMessage id="Actions" defaultMessage="Actions" />
        </Grid.Column>
      </Grid.Row>
      {locations.map((loc, key) => {
        const status =
          statuses?.items?.length > 0 &&
          statuses?.items.find((status) => status.value === loc.status)
            ? statuses?.items.find((status) => status.value === loc.status)
            : null;
        return (
          <Grid.Row key={key} className="locations-management-row">
            <Grid.Column width={columnSizes[0]} className="location-data">
              {loc.location.image_scales?.image && (
                <img
                  className="img-fluid"
                  sizes="(min-width: 1400px) 550px, 90vw"
                  srcset={`${loc.location['@id']}/${loc.location.image_scales.image[0].scales?.preview?.download} 1600w,
                                          ${loc.location['@id']}/${loc.location.image_scales.image[0].scales?.thumb?.download} 600w,
                                          ${loc.location['@id']}/${loc.location.image_scales.image[0].scales?.thumb?.download} 400w`}
                  src={`${loc.location['@id']}/${loc.location.image_scales.image[0].scales?.teaser?.download}`}
                  alt={loc.location.title}
                  title={loc.location.title}
                  loading=""
                />
              )}
              <h3>
                <UniversalLink href={loc?.location?.['@id']}>
                  {loc?.location?.title}
                </UniversalLink>
              </h3>
            </Grid.Column>
            <Grid.Column width={columnSizes[1]} className="location-status">
              <span className={`label status-${status?.value}`}>
                {status?.label}
              </span>
            </Grid.Column>
            <Grid.Column width={columnSizes[2]} className="location-expiration">
              {loc.creation_date ? (
                <span>{loc.creation_date.split('T')[0]}</span>
              ) : (
                <span>-</span>
              )}
            </Grid.Column>
            <Grid.Column width={columnSizes[3]} className="location-expiration">
              {loc.expiration_date ? (
                <span>{loc.expiration_date}</span>
              ) : (
                <span>-</span>
              )}
            </Grid.Column>
            <Grid.Column
              width={columnSizes[4]}
              className="location-action-wrapper"
            >
              {status && (
                <LocationActions
                  status={status?.value}
                  statuses={statuses?.items || []}
                  dispatch={dispatch}
                  location={loc}
                  isManager={isManager}
                />
              )}
            </Grid.Column>
          </Grid.Row>
        );
      })}
    </Grid>
  ) : (
    <FormattedMessage
      id="No location found"
      defaultMessage="No location found"
    />
  );
};
